import * as numbers from "common/numbers";
import * as strings from "common/strings";

const parseTable = (input) => {
  if (!strings.hasValue(input)) {
    return [];
  }
  return input
    .trim()
    .split(/\r?\n/)
    .map((row) => row.split("\t").map((cell) => cell.trim()));
};

export const parseFloatTable = (input) =>
  parseTable(input).map((row) => row.map(numbers.parseNumberString));

export const parseRmsAal = (input) => {
  const table = parseTable(input);

  if (
    table.length === 4 &&
    table.every((row) => row.length === 2) &&
    table[0][0] === "Statistics" &&
    table[1][0] === "Pure Premium" &&
    table[2][0] === "Standard Deviation" &&
    table[3][0] === "Coefficient of Variation"
  ) {
    return {
      expectedLoss: numbers.parseNumberString(table?.[1][1]),
      standardDeviation: numbers.parseNumberString(table?.[2][1]),
      coefficientOfVariation: numbers.parseNumberString(table?.[3][1]),
    };
  } else {
    return null;
  }
};

export const applyPastedValues = (ep, pastedText, lastClick) => {
  const firstPastedRowId = parseInt(lastClick.rowId);
  const pastedValues = parseFloatTable(pastedText);
  const hasValues = pastedValues.some((row) => {
    return row.some((cell) => cell != null);
  });

  if (pastedValues.length === 0 || !hasValues) {
    return ep;
  }

  const newExceedenceProbabilities = ep.map((row) => {
    const pastedRowValues = pastedValues[row.id - firstPastedRowId];
    if (pastedRowValues == null) {
      return row;
    }

    const newRow = { ...row };
    if (lastClick.columnId === "grossLossAep") {
      if (pastedRowValues?.length >= 1) {
        newRow.grossLossAep = pastedRowValues[0];
      }
      if (pastedRowValues?.length >= 2) {
        newRow.grossLossOep = pastedRowValues[1];
      }
    } else if (lastClick.columnId === "grossLossOep") {
      if (pastedRowValues?.length >= 1) {
        newRow.grossLossOep = pastedRowValues[0];
      }
    }

    return newRow;
  });

  return newExceedenceProbabilities;
};
